function Cinema_form_show_item(element) {
    this.$element = $(element);
    this.popup = i4_Popup.get(this.$element);

    this.selectors = {
	    ButtonEdit: '.js-button-edit',
	    ButtonDelete: '.js-button-delete',
    };
    
    this.data = {
	    ajaxUrl: 'ajax-url',
	    pluginName: 'plugin-name',
	    instanceId: 'instance-id',
	    url: 'url'
    };
    
    this.init = function() {
	    this.$buttonEdit = this.$element.find(this.selectors.ButtonEdit);
	    this.$buttonDelete = this.$element.find(this.selectors.ButtonDelete);

		this.dataAjaxUrl = this.$element.data(this.data.ajaxUrl);
		this.dataPluginName = this.$element.data(this.data.pluginName);
		this.dataInstanceId = this.$element.data(this.data.instanceId);
		this.dataUrl = this.$element.data(this.data.url);
	    
	    this.$buttonEdit.on('click', this.$onEditClick.bind(this)); 
	    this.$buttonDelete.on('click', this.$onDeleteClick.bind(this));


    };
    
    this.$onEditClick = function(event) {	   	   
		event.preventDefault();
		i4_Document_listener.set_click_position({top: event.pageY,  left: event.pageX});
		
		i4_Popup.add()
			.set_option({
		    	ajax_file: this.dataAjaxUrl+'?'+
		    		jQuery.param({
		    			js: this.dataPluginName,
		    			call: 'edit_show',
		    			instance_id: this.dataInstanceId,
		    			url: this.dataUrl
		    		}),
		    	position: this.popup,
		    	loader: true	
		    })
		    .add_callback('before_remove', (function() {
			    this.popup.show();
		    }).bind(this))
		    .run();
	    
		this.popup.hide();
    };
    
    this.$onDeleteClick = function(event) {	   	   
		event.preventDefault();
		i4_Document_listener.set_click_position({top: event.pageY,  left: event.pageX});
		
		i4_Popup.add()
			.set_option({
		    	ajax_file: this.dataAjaxUrl+'?'+
		    		jQuery.param({
		    			js: this.dataPluginName,
		    			call: 'delete_show',
		    			instance_id: this.dataInstanceId,
		    			url: this.dataUrl
		    		}),
		    	position: this.popup,
		    	loader: true
		    })
		    .add_callback('before_remove', (function() {
			    this.popup.show();
		    }).bind(this))
		    .run();
	    
		this.popup.hide();
    };
}
